import React, { useEffect } from 'react'
import { Option, LayoutPage, LayoutPageHeaderStyle, ScrollArea } from '@wallyhealth/web-core'
import intelService from '../../../services/intelService'
import styles from './index.module.css'

const PAGE_NAME = 'JoinStudioPage'

const JoinStudioPage = ({ onLocationPicked, locations }) => {
  useEffect(() => {
    intelService.recordView({ viewName: PAGE_NAME })
  }, [])

  const handleLocationSelect = (location) => {
    intelService.recordClick({
      clickName: 'LocationPick',
      viewName: PAGE_NAME,
      properties: {
        locationId: location.id,
        locationName: location.name
      }
    })

    onLocationPicked(location.id)
  }

  return (
    <LayoutPage
      title="Choose your home studio."
      description="Don't worry, you can still visit any of our other studios."
      headerStyle={LayoutPageHeaderStyle.FULL}>

      <div className={styles.options}>
        <ScrollArea>
        {locations
          .filter(it => it.isActive)
          .filter(it => it.isJoinFlowVisible)
          .map(location => (
            <Option
              key={`location-${location.id}`}
              title={location.name}
              description={location.address}
              className={styles.option}
              onClick={() => handleLocationSelect(location)}
            />
          ))
        }
        </ScrollArea>
      </div>
    </LayoutPage>
  )
}

export default JoinStudioPage
